import React, { FC, useEffect, useState } from 'react';

import { Box } from '@mui/system';
import { Button, Typography } from '@mui/material';

import { TypeOfUser } from '@pharmaplan/common';

import PharmacyViewProfile from '../Admin/Profile/Pharmacy/PharmacyViewProfile';
import PharmacistViewProfile from '../Admin/Profile/Pharmacist/PharmacistViewProfile';
import { setDrawerContentPadding } from '../../actions/drawerActions';
import { useAppDispatch } from '../../hooks/useAppDispatch';
import strings from '../../localization';

import styles from './styles';
import { nameLabels } from '../../helpers/Constants';

interface IViewUsersProfile {
  personnelIds: Array<string>;
}

const { pharmacist, pharmacy } = TypeOfUser;

const ViewUsersProfile: FC<IViewUsersProfile> = ({ personnelIds }) => {
  const dispatch = useAppDispatch();

  const [pharmacyId, pharmacistId] = personnelIds ?? ['', ''];
  const [segment, setSegment] = useState(pharmacy);
  const handleClick = (clickedItem: TypeOfUser) =>
    () => {
      setSegment(clickedItem);
    };

  const config = [
    {
      key: pharmacy,
      label: strings.pharmacy,
    },
    {
      key: pharmacist,
      label: nameLabels().roleLabel,
    },
  ];

  useEffect(() => {
    dispatch(setDrawerContentPadding('0'));
  }, []);

  return (
    <>
      <Box sx={styles.segmentContainer}>
        {config.map((item, index) => {
          const { key, label } = item;
          const isSelected = key === segment;
          const isFirstElement = index === 0;
          return (
            <>
              <Button onClick={handleClick(key)} key={key} sx={styles.button}>
                <Typography
                  sx={[styles.buttonLabel, isSelected && styles.selectedButton]}
                >
                  {label}
                </Typography>
              </Button>
              {isFirstElement && <Box sx={styles.divider} />}
            </>
          );
        })}
      </Box>
      <Box sx={styles.profileContainer}>
        {segment === pharmacy ? (
          <PharmacyViewProfile pharmacyId={pharmacyId} />
        ) : (
          <PharmacistViewProfile pharmacistId={pharmacistId} type="posted" />
        )}
      </Box>
    </>
  );
};

export default ViewUsersProfile;
